import OverviewController from './overview-list.controller';

require('./overview-list.scss');

const OverviewComponent = {
    selector: 'sbOverviewList',
    controller: OverviewController,
    template: require('./overview-list.html'),
    bindings: {
        carts: '<',
        query: '<',
    },
};

export default OverviewComponent;



// WEBPACK FOOTER //
// ./src/app/home/overview-list/index.js